import { ConfirmationDialogConfig } from "src/app/services/confirmation-dialog.service";
import { Action } from "./action";
import { filter, tap } from "rxjs";

export class DeleteAction extends Action {
  /**
   * Default config for delete confirmation dialog.
   */
  confirmDialogConfig: ConfirmationDialogConfig = {
    title: "Elimina",
    message: "Sicuro di voler proseguire?",
    confirmButtonLabel: "Conferma",
    cancelButtonLabel: "Annulla",
  };

  override execute(val: any, row: any, callback: Function): void {
    this.component.confirmationDialogService
      .showConfirmModal(this.confirmDialogConfig)
      .pipe(
        filter((confirmed: boolean) => !!confirmed),
        tap(() => {
          this.component.getDataService().deleteData(row.endpoint + (callback ? ('/' + callback()) : ("/" + val.id)))
        })
      )
      .subscribe();
  }

}
